module.exports = __webpack_public_path__ + "media/images/flags/4x3/wlf-de394ff1c79b7d620579a0af8e8702a5.svg";